<template>
  <ag-form
    :submit-label="$t('general.update')"
    :cancel-label="$t('general.cancel')"
    :submit-loading="loading"
    :hide-controls="!hasChanges"
    @submit="submit"
    @cancel="cancel"
  >
    <v-text-field
      v-model="internalValue.lengthOfChoiceList"
      :rules="$options.rules.lengthOfChoiceList"
      :label="$t('multitask.fields.settings.lengthOfChoiceList')"
      type="number"
    />

    <v-text-field
      v-model="internalValue.mistakePenality"
      :rules="$options.rules.mistakePenality"
      :label="$t('multitask.fields.settings.mistakePenality')"
      type="number"
    />
  </ag-form>
</template>

<script>
import AgForm from 'src/components/common/AgForm'
import FormRules from 'src/utils/form-rules'
import Helpers from 'src/utils/helpers'

export default {
  name: 'SettingsForm',
  components: {
    AgForm,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    internalValue: {},
  }),
  computed: {
    hasChanges () {
      return +this.value?.lengthOfChoiceList !== +this.internalValue?.lengthOfChoiceList
        || +this.value?.mistakePenality !== +this.internalValue?.mistakePenality
    },
  },
  watch: {
    value: {
      immediate: true,
      handler () {
        this.setInternalValue()
      },
    },
  },
  methods: {
    setInternalValue () {
      this.internalValue = Helpers.clone(this.value)
    },
    submit () {
      this.$emit('input', {
        lengthOfChoiceList: +this.internalValue.lengthOfChoiceList,
        mistakePenality: +this.internalValue.mistakePenality,
      })
    },
    cancel () {
      this.setInternalValue()
    },
  },
  rules: {
    lengthOfChoiceList: [
      FormRules.required('error.form.required'),
      FormRules.greater('error.form.greater', { number: 0 }),
    ],
    mistakePenality: [
      FormRules.required('error.form.required'),
      FormRules.greater('error.form.greater', { number: 0 }),
    ],
  },
}
</script>
